import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import Roll from 'react-reveal/Roll';
import Fade from 'react-reveal/Fade';
import config from 'react-reveal/globals';
import ReactResizeDetector from 'react-resize-detector';
import ReactInterval from 'react-interval';
import VisibilitySensor from 'react-visibility-sensor';
import ReactPlayer from 'react-player';

class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            width: 500,
            second_revealed: false,
            picture: 0,
            plumbing_pictures: [
                "/images/plumbing-1.jpg",
                "/images/plumbing-2.jpg",
                "/images/plumbing-3.jpg",
            ],
            hvac_pictures: [
                "/images/hvac-1.jpg",
                "/images/hvac-2.jpg",
                "/images/hvac-3.jpg",
            ],
            fire_fighting_pictures: [
                "/images/firefighting-1.jpg",
                "/images/firefighting-2.jpg",
                "/images/firefighting-3.jpg",
            ],
            elevator_pictures: [
                "/images/escalator-1.jpg",
                "/images/escalator-2.jpg",
                "/images/escalator-3.jpg",
            ],
        };
        config({ ssrFadeout: true });
        this.revealFirst = this.revealFirst.bind(this);
        this.handleWidth = this.handleWidth.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);
        this.handleInterval = this.handleInterval.bind(this);
    }

    scrollToTop() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    handleInterval() {
        let picture = this.state.picture;
        picture = picture == 2 ? 0 : picture + 1;
        this.setState({
            picture: picture
        });
    }

    handleWidth() {
        this.setState({ width: window.innerWidth });
    }

    revealFirst(isVisible) {
        if (isVisible)
            this.setState({
                second_revealed: true
            });
    }

    componentDidMount() {
        this.handleWidth();
    }

    render() {
        return (
            <Fragment >
                <ReactInterval timeout={3000} enabled={true} callback={() => this.handleInterval()} />
                <ReactResizeDetector handleWidth onResize={this.handleWidth} />

                <div className='row w-100 mt-5'>
                    <div className='col-lg-3 col-md-2 col-1'></div>
                    <div className='col-lg-6 col-md-8 col-10'>
                        <ReactPlayer
                            url='https://youtu.be/uQEphBmOaLY'
                            width={"100%"}
                            height={"100%"}
                            className="react-player-16-9"
                            muted={false}
                            loop={true}
                            controls={true}
                            playing={false}
                        />
                    </div>
                    <div className='col-lg-3 col-md-2 col-1'></div>
                </div>
                <div className="container mt-5 overflow-hidden" >
                    <Link to="/profile">
                        <h1 className="text-center fw-bolder">
                            <span className='text-dark'>
                                Tentang
                            </span>
                            <span className="text-sks-primary">
                                {` Sinergi`}
                            </span>
                            <span className="text-sks-secondary">
                                {` Karya`}
                            </span>
                            <span className="text-sks-primary">
                                {` Sejahtera`}
                            </span>
                        </h1>
                    </Link>
                    <p className="text-center px-5 mb-2 h4">
                        - profesional, terpercaya, menyediakan solusi, & melayani sepenuh hati -
                    </p>
                    <p className="text-center px-5 pb-5 h5">
                        Sebagai salah satu perusahaan yang terbaik di bidang mechanical/ electrical, kami ingin memfokuskan diri dalam melayani proyek – proyek komersial dan industri. Kami memberikan tenaga – tenaga ahli yang berpengalaman dalam menangani proyek untuk memberikan hasil dan kualitas yang maksimal dalam setiap pekerjaan.
                    </p>
                    <h2>
                        Servis
                    </h2>
                    <div className="row p-3 w-100">
                        <div className="col-1"></div>
                        <div className="col-5-md">
                            <VisibilitySensor offset={{ bottom: -250 }} partialVisibility={'bottom'} onChange={this.revealFirst} minTopValue={100} active={!this.state.second_revealed}>
                                {({ isVisible }) =>
                                    // <div>I am {isVisible ? 'visible' : 'invisible'}</div>
                                    <Roll when={isVisible}>
                                        <img src={this.state.plumbing_pictures[this.state.picture]} width="400px" height="400px" className="shape-1" />
                                    </Roll>
                                }
                            </VisibilitySensor>
                        </div>
                        <div className="col-5-md">
                            <h3>Plumbing</h3>
                            <ul>
                                <li>Hot & Cold Water Supply System</li>
                                <li>Water Filtration System</li>
                                <li>Drainage</li>
                                <li>Sanitation</li>
                                <li>Rain Water</li>
                                <li>Sewage Treatment</li>
                                <li>Ground Water tank and roof tank</li>
                                <li>Pump plumbing system</li>
                            </ul>
                        </div>
                    </div>
                    <div className="row p-3 w-100">
                        <div className="col-2"></div>
                        <div className="col-5-md">
                            <Roll>
                                <img src={this.state.hvac_pictures[this.state.picture]} width="400px" height="400px" className="shape-1 " />
                            </Roll>
                        </div>
                        <div className="col-md-5">
                            <h3>HVAC</h3>
                            <ul>
                                <li>Ducting installation service</li>
                                <li>Chilled water piping system</li>
                                <li>Ventilation system</li>
                                <li>Fresh air system</li>
                                <li>Air Conditioning system</li>
                            </ul>
                        </div>
                    </div>
                    <div className="row p-3 w-100">
                        <div className="col-1"></div>
                        <div className="col-5-md">
                            <Roll>
                                <img src={this.state.fire_fighting_pictures[this.state.picture]} width="400px" height="400px" className="shape-4" />
                            </Roll>
                        </div>
                        <div className="col-5-md">
                            <h3>Fire Fighting</h3>
                            <ul>
                                <li>Sprinkler installation & modification system</li>
                                <li>Hydrant installation & modification system</li>
                                <li>Emergency / Exit lighting system</li>
                                <li>Fire detection & alarm</li>
                                <li>Fire suppression system</li>
                                <li>Pump fire fighting system</li>
                            </ul>
                        </div>
                    </div>
                    <div className="row p-3 w-100">
                        <div className="col-5-md">
                            <Roll>
                                <img src={this.state.elevator_pictures[this.state.picture]} width="400px" height="400px" className="shape-1" />
                            </Roll>
                        </div>
                        <div className="text-left col-5-md">
                            <h3>Elevator & escalator</h3>
                            <ul>
                                <li>Elevator installation system</li>
                                <li>Escalator installation system</li>
                            </ul>
                        </div>
                    </div>
                    <h2>
                        Klien
                    </h2>
                    <div className="row p-3 w-100 mt-3 mx-0">
                        <div className="col-sm">
                            <Link to="/projects" onClick={this.scrollToTop}>
                                <Fade>
                                    <img src="/images/pahoa.png" className={`img-fluid ${this.state.width < 766 ? this.state.width < 466 ? 'p-3' : 'p-5' : ''}`} />
                                </Fade>
                            </Link>
                        </div>
                        <div className="col-sm">
                            <Link to="/projects" onClick={this.scrollToTop}>
                                <Fade>
                                    <img src="/images/trisakti.png" className={`img-fluid ${this.state.width < 766 ? this.state.width < 466 ? 'p-3' : 'p-5' : ''}`} />
                                </Fade>
                            </Link>
                        </div>
                        <div className="col-sm">
                            <Link to="/projects" onClick={this.scrollToTop}>
                                <Fade>
                                    <img src="/images/waskita.png" className={`img-fluid ${this.state.width < 766 ? this.state.width < 466 ? 'p-3' : 'p-5' : ''}`} />
                                </Fade>
                            </Link>
                        </div>
                        <div className="col-sm">
                            <Link to="/projects" onClick={this.scrollToTop}>
                                <Fade>
                                    <img src="/images/unnes.png" className={`img-fluid ${this.state.width < 766 ? this.state.width < 466 ? 'p-3' : 'p-5' : ''}`} />
                                </Fade>
                            </Link>
                        </div>
                        <div className="col-sm">
                            <Link to="/projects" onClick={this.scrollToTop}>
                                <Fade>
                                    <img src="/images/unlam.png" className={`img-fluid ${this.state.width < 766 ? this.state.width < 466 ? 'p-3' : 'p-5' : ''}`} />
                                </Fade>
                            </Link>
                        </div>
                        <div className="col-sm">
                            <Link to="/projects" onClick={this.scrollToTop}>
                                <Fade>
                                    <img src="/images/novotel.png" className={`img-fluid ${this.state.width < 766 ? this.state.width < 466 ? 'p-3' : 'p-5' : ''}`} />
                                </Fade>
                            </Link>
                        </div>
                        <div className="col-sm">
                            <Link to="/projects" onClick={this.scrollToTop}>
                                <Fade>
                                    <img src="/images/grandhika.png" className={`img-fluid ${this.state.width < 766 ? this.state.width < 466 ? 'p-3' : 'p-5' : ''}`} />
                                </Fade>
                            </Link>
                        </div>
                    </div>
                    <div className="row p-3 w-100 mt-3 mx-0">
                        <div className="col-sm">
                            <Link to="/projects" onClick={this.scrollToTop}>
                                <Fade>
                                    <img src="/images/columbia.png" className={`img-fluid ${this.state.width < 766 ? this.state.width < 466 ? 'p-3' : 'p-5' : ''}`} />
                                </Fade>
                            </Link>
                        </div>
                        <div className="col-sm">
                            <Link to="/projects" onClick={this.scrollToTop}>
                                <Fade>
                                    <img src="/images/angkasa.png" className={`img-fluid ${this.state.width < 766 ? this.state.width < 466 ? 'p-3' : 'p-5' : ''}`} />
                                </Fade>
                            </Link>
                        </div>
                        <div className="col-sm">
                            <Link to="/projects" onClick={this.scrollToTop}>
                                <Fade>
                                    <img src="/images/epson.png" className={`img-fluid ${this.state.width < 766 ? this.state.width < 466 ? 'p-3' : 'p-5' : ''}`} />
                                </Fade>
                            </Link>
                        </div>
                        <div className="col-sm">
                            <Link to="/projects" onClick={this.scrollToTop}>
                                <Fade>
                                    <img src="/images/adhi.png" className={`img-fluid ${this.state.width < 766 ? this.state.width < 466 ? 'p-3' : 'p-5' : ''}`} />
                                </Fade>
                            </Link>
                        </div>
                        <div className="col-sm">
                            <Link to="/projects" onClick={this.scrollToTop}>
                                <Fade>
                                    <img src="/images/megapolitan.png" className={`img-fluid ${this.state.width < 766 ? this.state.width < 466 ? 'p-3' : 'p-5' : ''}`} />
                                </Fade>
                            </Link>
                        </div>
                        <div className="col-sm">
                            <Link to="/projects" onClick={this.scrollToTop}>
                                <Fade>
                                    <img src="/images/adhi-persada.png" className={`img-fluid ${this.state.width < 766 ? this.state.width < 466 ? 'p-3' : 'p-5' : ''}`} />
                                </Fade>
                            </Link>
                        </div>
                        <div className="col-sm">
                            <Link to="/projects" onClick={this.scrollToTop}>
                                <Fade>
                                    <img src="/images/casm.png" className={`img-fluid ${this.state.width < 766 ? this.state.width < 466 ? 'p-3' : 'p-5' : ''}`} />
                                </Fade>
                            </Link>
                        </div>
                    </div>
                    <div className="row p-3 w-100 mt-3 mx-0">
                        <div className="col-sm">
                            <Link to="/projects" onClick={this.scrollToTop}>
                                <Fade>
                                    <img src="/images/wika.png" className={`img-fluid ${this.state.width < 766 ? this.state.width < 466 ? 'p-3' : 'p-5' : ''}`} />
                                </Fade>
                            </Link>
                        </div>
                        <div className="col-sm">
                            <Link to="/projects" onClick={this.scrollToTop}>
                                <Fade>
                                    <img src="/images/untar.png" className={`img-fluid ${this.state.width < 766 ? this.state.width < 466 ? 'p-3' : 'p-5' : ''}`} />
                                </Fade>
                            </Link>
                        </div>
                        <div className="col-sm">
                            <Link to="/projects" onClick={this.scrollToTop}>
                                <Fade>
                                    <img src="/images/jababeka.png" className={`img-fluid ${this.state.width < 766 ? this.state.width < 466 ? 'p-3' : 'p-5' : ''}`} />
                                </Fade>
                            </Link>
                        </div>
                        <div className="col-sm">
                            <Link to="/projects" onClick={this.scrollToTop}>
                                <Fade>
                                    <img src="/images/sadira.png" className={`img-fluid ${this.state.width < 766 ? this.state.width < 466 ? 'p-3' : 'p-5' : ''}`} />
                                </Fade>
                            </Link>
                        </div>
                        <div className="col-sm">
                            <Link to="/projects" onClick={this.scrollToTop}>
                                <Fade>
                                    <img src="/images/utama.png" className={`img-fluid ${this.state.width < 766 ? this.state.width < 466 ? 'p-3' : 'p-5' : ''}`} />
                                </Fade>
                            </Link>
                        </div>
                        <div className="col-sm">
                            <Link to="/projects" onClick={this.scrollToTop}>
                                <Fade>
                                    <img src="/images/ciputra.png" className={`img-fluid ${this.state.width < 766 ? this.state.width < 466 ? 'p-3' : 'p-5' : ''}`} />
                                </Fade>
                            </Link>
                        </div>
                    </div>
                    <div className="row p-3 w-100 mt-3 mx-0">
                        <div className="col-sm">
                            <Link to="/projects" onClick={this.scrollToTop}>
                                <Fade>
                                    <img src="/images/rsup.png" className={`img-fluid ${this.state.width < 766 ? this.state.width < 466 ? 'p-3' : 'p-5' : ''}`} />
                                </Fade>
                            </Link>
                        </div>
                        <div className="col-sm">
                            <Link to="/projects" onClick={this.scrollToTop}>
                                <Fade>
                                    <img src="/images/taruma.png" className={`img-fluid ${this.state.width < 766 ? this.state.width < 466 ? 'p-3' : 'p-5' : ''}`} />
                                </Fade>
                            </Link>
                        </div>
                        <div className="col-sm">
                            <Link to="/projects" onClick={this.scrollToTop}>
                                <Fade>
                                    <img src="/images/koja.png" className={`img-fluid ${this.state.width < 766 ? this.state.width < 466 ? 'p-3' : 'p-5' : ''}`} />
                                </Fade>
                            </Link>
                        </div>
                        <div className="col-sm">
                            <Link to="/projects" onClick={this.scrollToTop}>
                                <Fade>
                                    <img src="/images/carolus.png" className={`img-fluid ${this.state.width < 766 ? this.state.width < 466 ? 'p-3' : 'p-5' : ''}`} />
                                </Fade>
                            </Link>
                        </div>
                        <div className="col-sm">
                            <Link to="/projects" onClick={this.scrollToTop}>
                                <Fade>
                                    <img src="/images/bangun.png" className={`img-fluid ${this.state.width < 766 ? this.state.width < 466 ? 'p-3' : 'p-5' : ''}`} />
                                </Fade>
                            </Link>
                        </div>
                    </div>

                    <h2>
                        Produk
                    </h2>
                    <div className="row p-3 w-100 mt-3 mx-0">
                        <div className="col-sm text-center">
                            <h4>VRV</h4>
                            <Fade>
                                <img src="images/vrv.png" className={`img-fluid grow shape-${Math.floor((Math.random() * 5) + 1)}`} />
                            </Fade>
                        </div>
                        <div className="col-sm text-center">
                            <h4>Chiller</h4>
                            <Fade>
                                <img src="images/chiller.png" className={`img-fluid grow shape-${Math.floor((Math.random() * 5) + 1)}`} />
                            </Fade>
                        </div>
                        <div className="col-sm text-center h-50">
                            <h4>Elevator</h4>
                            <Fade>
                                <img src="images/elevator.png" className={`img-fluid grow shape-${Math.floor((Math.random() * 5) + 1)}`} />
                            </Fade>
                        </div>
                        <div className="col-sm text-center">
                            <h4>Escalator</h4>
                            <Fade>
                                <img src="images/escalator.png" className={`img-fluid grow shape-${Math.floor((Math.random() * 5) + 1)}`} />
                            </Fade>
                        </div>
                    </div>
                    <h2>
                        Didukung Oleh
                    </h2>
                    <div className="row p-3 w-100 mt-3 mx-0">
                        <div className="col-sm">
                            <Fade>
                                <a href="https://www.samsung.com/id/air-conditioners/" target="_blank">
                                    <img src="/images/samsung.png" className={`img-fluid ${this.state.width < 766 ? this.state.width < 466 ? 'p-3' : 'p-5' : ''}`} />
                                </a>
                            </Fade>
                        </div>
                        <div className="col-sm">
                            <Fade>
                                <a href="http://daikinapplied.co.id/" target="_blank">
                                    <img src="/images/mcquay.png" className={`img-fluid ${this.state.width < 766 ? this.state.width < 466 ? 'p-3' : 'p-5' : ''}`} />
                                </a>
                            </Fade>
                        </div>
                        <div className="col-sm">
                            <Fade>
                                <a href="http://www.daikin.co.id/" target="_blank">
                                    <img src="/images/daikin.png" className={`img-fluid ${this.state.width < 766 ? this.state.width < 466 ? 'p-3' : 'p-5' : ''}`} />
                                </a>
                            </Fade>
                        </div>
                        <div className="col-sm">
                            <Fade>
                                <a href="https://www.trane.com/commercial/asia-pacific/id/en.html" target="_blank">
                                    <img src="/images/trane.png" className={`img-fluid ${this.state.width < 766 ? this.state.width < 466 ? 'p-3' : 'p-5' : ''}`} />
                                </a>
                            </Fade>
                        </div>
                        <div className="col-sm">
                            <Fade>
                                <a href="https://www.gree.id/" target="_blank">
                                    <img src="/images/gree.png" className={`img-fluid ${this.state.width < 766 ? this.state.width < 466 ? 'p-3' : 'p-5' : ''}`} />
                                </a>
                            </Fade>
                        </div>
                        <div className="col-sm">
                            <Fade>
                                <a href="https://id.mitsubishielectric.com/id/products-solutions/air-conditioning/index.html" target="_blank">
                                    <img src="/images/mitsubishi.png" className={`img-fluid ${this.state.width < 766 ? this.state.width < 466 ? 'p-3' : 'p-5' : ''}`} />
                                </a>
                            </Fade>
                        </div>
                    </div>
                    <div className="row p-3 w-100 justify-content-center mx-0">
                        <div className="col-sm-2">
                            <Fade>
                                <a href="https://www.panasonic.com/id/consumer/home-appliances/air-conditioners.html" target="_blank">
                                    <img src="/images/panasonic.png" className={`img-fluid ${this.state.width < 766 ? this.state.width < 466 ? 'p-3' : 'p-5' : ''}`} />
                                </a>
                            </Fade>
                        </div>
                        <div className="col-sm-2">
                            <Fade>
                                <a href="https://www.hitachi.co.id/" target="_blank">
                                    <img src="/images/hitachi.png" className={`img-fluid ${this.state.width < 766 ? this.state.width < 466 ? 'p-3' : 'p-5' : ''}`} />
                                </a>
                            </Fade>
                        </div>
                        <div className="col-sm-2">
                            <Fade>
                                <a href="http://www.ticachina.com/en/" target="_blank">
                                    <img src="/images/tica.png" className={`img-fluid ${this.state.width < 766 ? this.state.width < 466 ? 'p-3' : 'p-5' : ''}`} />
                                </a>
                            </Fade>
                        </div>
                        <div className="col-sm-2">
                            <Fade>
                                <a href="https://id.midea.com/" target="_blank">
                                    <img src="/images/midea.png" className={`img-fluid ${this.state.width < 766 ? this.state.width < 466 ? 'p-3' : 'p-5' : ''}`} />
                                </a>
                            </Fade>
                        </div>
                        <div className="col-sm-2">
                            <Fade>
                                <a href="https://www.lg.com/id/air-conditioner" target="_blank">
                                    <img src="/images/lg.png" className={`img-fluid ${this.state.width < 766 ? this.state.width < 466 ? 'p-3' : 'p-5' : ''}`} />
                                </a>
                            </Fade>
                        </div>
                        <div className="col-sm-2">
                            <Fade>
                                <a href="http://www.fujielevator.co.id/" target="_blank">
                                    <img src="/images/fuji.png" className={`img-fluid ${this.state.width < 766 ? this.state.width < 466 ? 'p-3' : 'p-5' : ''}`} />
                                </a>
                            </Fade>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }

}

export default Home;